export enum FileProcessedErrorType {
  Unknown = 'Unknown',
  MissingInitialFile = 'MissingInitialFile',
  InvalidFileType = 'InvalidFileType',
  InvalidFile = 'InvalidFile',
}